import { useContext, useEffect, useMemo, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { composeFilter, Filter } from 'src/utils/composeFilter.ts';
import { ConfigContext } from 'src/configContext.ts';
import { getHomePageConfig } from 'src/actuators/home/HomePageMapping.ts';
import { buildReadableFilterStatus } from 'src/actuators/home/buildReadableFilterStatus.ts';

export function useGetHomeBreadcrumb({
    filter,
}: {
    filter: Filter;
}) {
    const client = useApolloClient();
    const { userSettings, mandatoryFilterConfig } = useContext(ConfigContext);
    const { query, filterConfig } = useMemo(() => getHomePageConfig(userSettings.currentRegion), [userSettings]);
    const [state, setData] = useState<string>('');
    useEffect(() => {
        client.query({
            query,
            variables: {
                filter: composeFilter(
                    mandatoryFilterConfig.config,
                    mandatoryFilterConfig.values,
                    userSettings.currentLocale,
                ),
                locale: userSettings.currentLocale,
                shoppingCenter: userSettings.shoppingCenter ?? '',
            },
        }).then((data) => {
            if (data.data !== undefined) {
                const value = buildReadableFilterStatus(filter, data.data);
                if (value.length > 0) {
                    setData(value);
                }
            }
            // eslint-disable-next-line no-console
        }).catch((err) => console.error(err));
    }, [
        client,
        query,
        filterConfig,
        filter,
        mandatoryFilterConfig,
        userSettings,
    ]);
    return state;
}
